module.exports = __webpack_public_path__ + "img/data_downlod_btn.67545734.png";